<template>
  <div class="common-list">
    <!--导航-->
    <div class="dk-nav">
      <nav-bar title="常见问题" url="/home" />
    </div>

    <!--常见问题列表-->
    <div style="margin-top: 1px; margin-bottom: 1px;">
      <template v-if="loading">
      <template v-if="common.data">
      <div class="van-cell" style="margin-bottom: 3px;" v-for="item in filterBy(common.data,city)">
        <div class="van-image" style="width: 80px; height: 85px; margin-right: 5px;">
          <img :src="uploadsUrl+item.picture" class="van-image__img" style="object-fit: cover;">
        </div>

        <div class="van-cell__title">
          <span>{{item.title}}</span>
          <div class="van-cell__label van-multi-ellipsis--l3">{{item.description}}</div>
        </div>
      </div>
      </template>
      </template>
      <template v-else>
        <van-loading type="spinner" color="#ff8917" vertical />
      </template>
    </div>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import NavBar from '../../components/NavBar.vue'
export default {
    'name': 'commonList',
    data() {
        return {
          loading: false
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            common: state => state.common.common_list
        })
    },
    methods: {
      ...mapActions(['requestCommons']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                if(value == "重庆") {
                  return lists.city.match('市辖区');
                }else{
                  return lists.city.match(value);
                }
            })
        }
    },
    components: {
      NavBar
    },
    mounted() {
      this.requestCommons({"thit":this,"city":this.city});
    },
    beforeCreate() {
        this.uploadsUrl = 'https://a.chengdai.cn/uploads/'
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.common-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.common-list >>> .van-nav-bar__text {
  color: #fff;
}
.common-list >>> .van-nav-bar__title {
  color: #fff;
}
.common-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.common-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
